import { STATS } from "@/data/content";

export default function StatsBar() {
  return (
    <section className="bg-[#0C2749] text-white" data-testid="stats-bar">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-12 grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
        {STATS.map((s, i) => (
          <div key={i} className="border-l border-white/15 pl-5 first:border-l-0 first:pl-0">
            <p
              className="text-3xl md:text-5xl font-bold tracking-tight count-pop"
              style={{ fontFamily: "Outfit" }}
            >
              {s.value}
            </p>
            <p className="mt-2 text-xs uppercase tracking-[0.2em] text-[#2C80C8]">{s.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
